import React, { FC } from 'react';
import { IconProps } from '../../@types/ui';

const CartIcon: FC<IconProps> = ({ width, height }) => {
  return (
    <svg
      className={`w-${width} h-${height}`}
      aria-hidden="true"
      xmlns="http://www.w3.org/2000/svg"
      fill="none"
      viewBox="0 0 18 20"
    >
      <path
        stroke="currentColor"
        strokeLinecap="round"
        strokeLinejoin="round"
        strokeWidth="1.5"
        d="M6 15a2 2 0 1 0 0 4 2 2 0 0 0 0-4Zm0 0h8m-8 0-1-4m9 4a2 2 0 1 0 0 4 2 2 0 0 0 0-4Zm-9-4h10l2-7H3m2 7L3 4m0 0-.792-3H1"
      />
    </svg>
  );
};

const ContactCardIcon: FC<IconProps> = ({ width, height }) => {
  return (
    <svg
      className={`w-${width} h-${height}`}
      viewBox="0 0 24 24"
      version="1.1"
      xmlns="http://www.w3.org/2000/svg"
    >
      <g
        id="icons"
        stroke="none"
        strokeWidth="1"
        fill="none"
        fill-rule="evenodd"
      >
        <g id="card" fill="currentColor" fillRule="nonzero">
          <path
            d="M19.75,4 C20.9926407,4 22,5.00735931 22,6.25 L22,17.754591 C22,18.9972317 20.9926407,20.004591 19.75,20.004591 L4.25,20.004591 C3.00735931,20.004591 2,18.9972317 2,17.754591 L2,6.25 C2,5.00735931 3.00735931,4 4.25,4 L19.75,4 Z M19.75,5.5 L4.25,5.5 C3.83578644,5.5 3.5,5.83578644 3.5,6.25 L3.5,17.754591 C3.5,18.1688046 3.83578644,18.504591 4.25,18.504591 L19.75,18.504591 C20.1642136,18.504591 20.5,18.1688046 20.5,17.754591 L20.5,6.25 C20.5,5.83578644 20.1642136,5.5 19.75,5.5 Z M9.75,12.5 C10.1642136,12.5 10.5,12.8357864 10.5,13.25 L10.5,13.7427321 L10.4921036,13.8512782 C10.3293159,14.964219 9.39767421,15.5009403 7.99995063,15.5009403 C6.60213369,15.5009403 5.67047899,14.9636623 5.50787101,13.8501298 L5.5,13.7417575 L5.5,13.25 C5.5,12.8357864 5.83578644,12.5 6.25,12.5 L9.75,12.5 Z M13.2522936,12.9961404 L17.75,12.9961404 C18.1642136,12.9961404 18.5,13.3319269 18.5,13.7461404 C18.5,14.1258362 18.2178461,14.4396314 17.8517706,14.4892938 L17.75,14.4961404 L13.2522936,14.4961404 C12.83808,14.4961404 12.5022936,14.160354 12.5022936,13.7461404 C12.5022936,13.3664447 12.7844475,13.0526495 13.150523,13.002987 L13.2522936,12.9961404 L17.75,12.9961404 L13.2522936,12.9961404 Z M8,8.50218109 C8.82841293,8.50218109 9.4999743,9.17374246 9.4999743,10.0021554 C9.4999743,10.8305683 8.82841293,11.5021297 8,11.5021297 C7.17158707,11.5021297 6.5000257,10.8305683 6.5000257,10.0021554 C6.5000257,9.17374246 7.17158707,8.50218109 8,8.50218109 Z M13.2522936,9.5 L17.75,9.5 C18.1642136,9.5 18.5,9.83578644 18.5,10.25 C18.5,10.6296958 18.2178461,10.943491 17.8517706,10.9931534 L17.75,11 L13.2522936,11 C12.83808,11 12.5022936,10.6642136 12.5022936,10.25 C12.5022936,9.87030423 12.7844475,9.55650904 13.150523,9.50684662 L13.2522936,9.5 L17.75,9.5 L13.2522936,9.5 Z"
            id="color"
          ></path>
        </g>
      </g>
    </svg>
  );
};
const ContactCardIcon2: FC<IconProps> = ({ width, height }) => {
  return (
    <svg
      className={`w-${width} h-${height}`}
      viewBox="0 0 24 24"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        fill="none"
        stroke="currentColor"
        strokeWidth="2"
        d="M5,12 C3.343,12 2,10.657 2,9 C2,7.343 3.343,6 5,6 C6.657,6 8,7.343 8,9 C8,10.657 6.657,12 5,12 Z M9,18 L9,16 C9,13.7504 7.2128,12 4.964,12 L5.0184,12 C2.7688,12 1,13.7504 1,16 L1,18 M12,7 L24,7 M12,17 L22,17 M12,12 L19,12"
      />
    </svg>
  );
};

const SettingsIcon: FC<IconProps> = ({ width, height }) => {
  return (
    <svg
      className={`w-${width} h-${height}`}
      aria-hidden="true"
      fill="currentColor"
      viewBox="-1 0 19 19"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path d="M16.014 8.86v1.44a.587.587 0 0 1-.468.556l-1.182.204a.463.463 0 0 1-.114.006 5.902 5.902 0 0 1-.634 1.528.455.455 0 0 1 .078.084l.691.98a.586.586 0 0 1-.062.725l-1.02 1.02a.586.586 0 0 1-.724.061l-.98-.69a.444.444 0 0 1-.085-.078 5.908 5.908 0 0 1-1.544.637.502.502 0 0 1 0 .175l-.182 1.053a.667.667 0 0 1-.633.532h-1.31a.667.667 0 0 1-.633-.532l-.182-1.053a.495.495 0 0 1 0-.175 5.908 5.908 0 0 1-1.544-.637.444.444 0 0 1-.085.077l-.98.691a.586.586 0 0 1-.725-.062l-1.02-1.02a.586.586 0 0 1-.061-.723l.691-.98a.454.454 0 0 1 .077-.085 5.901 5.901 0 0 1-.633-1.528.466.466 0 0 1-.114-.006l-1.182-.204a.586.586 0 0 1-.468-.556V8.86a.586.586 0 0 1 .468-.556L2.636 8.1a.437.437 0 0 1 .114-.005 5.912 5.912 0 0 1 .633-1.528.466.466 0 0 1-.077-.085l-.691-.98a.587.587 0 0 1 .061-.724l1.02-1.02a.587.587 0 0 1 .725-.062l.98.691a.444.444 0 0 1 .085.078 5.903 5.903 0 0 1 1.528-.634.433.433 0 0 1 .005-.114l.204-1.182a.586.586 0 0 1 .556-.468h1.442a.586.586 0 0 1 .556.468l.204 1.182a.448.448 0 0 1 .005.114 5.908 5.908 0 0 1 1.528.634.444.444 0 0 1 .085-.078l.98-.691a.586.586 0 0 1 .724.062l1.02 1.02a.586.586 0 0 1 .062.724l-.691.98a.467.467 0 0 1-.078.085 5.902 5.902 0 0 1 .634 1.528.434.434 0 0 1 .114.005l1.182.204a.587.587 0 0 1 .468.556zm-4.955.72a2.559 2.559 0 1 0-2.56 2.56 2.559 2.559 0 0 0 2.56-2.56z" />
    </svg>
  );
};

const ListIcon: FC<IconProps> = ({ width, height }) => {
  return (
    <svg
      className={`w-${width} h-${height} text-gray-800 dark:text-white`}
      aria-hidden="true"
      xmlns="http://www.w3.org/2000/svg"
      fill="none"
      viewBox="0 0 20 16"
    >
      <path
        stroke="currentColor"
        strokeLinecap="round"
        strokeLinejoin="round"
        strokeWidth="2"
        d="M9 5h6M9 8h6m-6 3h6M4.996 5h.01m-.01 3h.01m-.01 3h.01M2 1h16a1 1 0 0 1 1 1v12a1 1 0 0 1-1 1H2a1 1 0 0 1-1-1V2a1 1 0 0 1 1-1Z"
      />
    </svg>
  );
};

const LockIcon: FC<IconProps> = ({ width, height }) => {
  return (
    <svg
      className={`w-${width} h-${height}`}
      aria-hidden="true"
      xmlns="http://www.w3.org/2000/svg"
      fill="none"
      viewBox="0 0 16 20"
    >
      <path
        stroke="currentColor"
        strokeLinecap="round"
        strokeLinejoin="round"
        strokeWidth="2"
        d="M11.5 8V4.5a3.5 3.5 0 1 0-7 0V8M8 12v3M2 8h12a1 1 0 0 1 1 1v9a1 1 0 0 1-1 1H2a1 1 0 0 1-1-1V9a1 1 0 0 1 1-1Z"
      />
    </svg>
  );
};

const ReceiptIcon: FC<IconProps> = ({ width, height }) => {
  return (
    <svg
      className={`w-${width} h-${height}`}
      aria-hidden="true"
      xmlns="http://www.w3.org/2000/svg"
      fill="none"
      viewBox="0 0 14 20"
    >
      <path
        stroke="currentColor"
        strokeLinecap="round"
        strokeLinejoin="round"
        strokeWidth="2"
        d="M4 6h6m-6 4h6m-6 4h6M1 1v18l2-2 2 2 2-2 2 2 2-2 2 2V1l-2 2-2-2-2 2-2-2-2 2-2-2Z"
      />
    </svg>
  );
};
const ReceiptIcon2: FC<IconProps> = ({ width, height }) => {
  return (
    <svg
      className={`w-${width} h-${height}`}
      viewBox="0 0 24 24"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        fill="currentcolor"
        d="M15.78 2H8.22C4.44 2 3.5 3.01 3.5 7.04V18.3C3.5 20.96 4.96 21.59 6.73 19.69L6.74 19.68C7.56 18.81 8.81 18.88 9.52 19.83L10.53 21.18C11.34 22.25 12.65 22.25 13.46 21.18L14.47 19.83C15.19 18.87 16.44 18.8 17.26 19.68C19.04 21.58 20.49 20.95 20.49 18.29V7.04C20.5 3.01 19.56 2 15.78 2ZM7.78 12C7.23 12 6.78 11.55 6.78 11C6.78 10.45 7.23 10 7.78 10C8.33 10 8.78 10.45 8.78 11C8.78 11.55 8.33 12 7.78 12ZM7.78 8C7.23 8 6.78 7.55 6.78 7C6.78 6.45 7.23 6 7.78 6C8.33 6 8.78 6.45 8.78 7C8.78 7.55 8.33 8 7.78 8ZM16.23 11.75H10.73C10.32 11.75 9.98 11.41 9.98 11C9.98 10.59 10.32 10.25 10.73 10.25H16.23C16.64 10.25 16.98 10.59 16.98 11C16.98 11.41 16.64 11.75 16.23 11.75ZM16.23 7.75H10.73C10.32 7.75 9.98 7.41 9.98 7C9.98 6.59 10.32 6.25 10.73 6.25H16.23C16.64 6.25 16.98 6.59 16.98 7C16.98 7.41 16.64 7.75 16.23 7.75Z"
      />
    </svg>
  );
};
const ShopIcon: FC<IconProps> = ({ width, height }) => {
  return (
    <svg
      className={`w-${width} h-${height}`}
      viewBox="0 0 24 24"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M4.62127 4.51493C4.80316 3.78737 4.8941 3.42359 5.16536 3.21179C5.43663 3 5.8116 3 6.56155 3H17.4384C18.1884 3 18.5634 3 18.8346 3.21179C19.1059 3.42359 19.1968 3.78737 19.3787 4.51493L20.5823 9.32938C20.6792 9.71675 20.7276 9.91044 20.7169 10.0678C20.6892 10.4757 20.416 10.8257 20.0269 10.9515C19.8769 11 19.6726 11 19.2641 11C18.7309 11 18.4644 11 18.2405 10.9478C17.6133 10.8017 17.0948 10.3625 16.8475 9.76782C16.7593 9.55555 16.7164 9.29856 16.6308 8.78457C16.6068 8.64076 16.5948 8.56886 16.5812 8.54994C16.5413 8.49439 16.4587 8.49439 16.4188 8.54994C16.4052 8.56886 16.3932 8.64076 16.3692 8.78457L16.2877 9.27381C16.2791 9.32568 16.2747 9.35161 16.2704 9.37433C16.0939 10.3005 15.2946 10.9777 14.352 10.9995C14.3289 11 14.3026 11 14.25 11C14.1974 11 14.1711 11 14.148 10.9995C13.2054 10.9777 12.4061 10.3005 12.2296 9.37433C12.2253 9.35161 12.2209 9.32568 12.2123 9.27381L12.1308 8.78457C12.1068 8.64076 12.0948 8.56886 12.0812 8.54994C12.0413 8.49439 11.9587 8.49439 11.9188 8.54994C11.9052 8.56886 11.8932 8.64076 11.8692 8.78457L11.7877 9.27381C11.7791 9.32568 11.7747 9.35161 11.7704 9.37433C11.5939 10.3005 10.7946 10.9777 9.85199 10.9995C9.82887 11 9.80258 11 9.75 11C9.69742 11 9.67113 11 9.64801 10.9995C8.70541 10.9777 7.90606 10.3005 7.7296 9.37433C7.72527 9.35161 7.72095 9.32568 7.7123 9.27381L7.63076 8.78457C7.60679 8.64076 7.59481 8.56886 7.58122 8.54994C7.54132 8.49439 7.45868 8.49439 7.41878 8.54994C7.40519 8.56886 7.39321 8.64076 7.36924 8.78457C7.28357 9.29856 7.24074 9.55555 7.15249 9.76782C6.90524 10.3625 6.38675 10.8017 5.75951 10.9478C5.53563 11 5.26905 11 4.73591 11C4.32737 11 4.12309 11 3.97306 10.9515C3.58403 10.8257 3.31078 10.4757 3.28307 10.0678C3.27239 9.91044 3.32081 9.71675 3.41765 9.32938L4.62127 4.51493Z"
        fill="currentColor"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M5.01747 12.5002C5 12.9211 5 13.4152 5 14V20C5 20.9428 5 21.4142 5.29289 21.7071C5.58579 22 6.05719 22 7 22H10V18C10 17.4477 10.4477 17 11 17H13C13.5523 17 14 17.4477 14 18V22H17C17.9428 22 18.4142 22 18.7071 21.7071C19 21.4142 19 20.9428 19 20V14C19 13.4152 19 12.9211 18.9825 12.5002C18.6177 12.4993 18.2446 12.4889 17.9002 12.4087C17.3808 12.2877 16.904 12.0519 16.5 11.7267C15.9159 12.1969 15.1803 12.4807 14.3867 12.499C14.3456 12.5 14.3022 12.5 14.2609 12.5H14.2608L14.25 12.5L14.2392 12.5H14.2391C14.1978 12.5 14.1544 12.5 14.1133 12.499C13.3197 12.4807 12.5841 12.1969 12 11.7267C11.4159 12.1969 10.6803 12.4807 9.88668 12.499C9.84555 12.5 9.80225 12.5 9.76086 12.5H9.76077L9.75 12.5L9.73923 12.5H9.73914C9.69775 12.5 9.65445 12.5 9.61332 12.499C8.8197 12.4807 8.08409 12.1969 7.5 11.7267C7.09596 12.0519 6.6192 12.2877 6.09984 12.4087C5.75542 12.4889 5.38227 12.4993 5.01747 12.5002Z"
        fill="currentColor"
      />
    </svg>
  );
};
const TagIcon: FC<IconProps> = ({ width, height }) => {
  return (
    <svg
      className={`w-${width} h-${height}`}
      viewBox="0 0 24 24"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M7.0498 7.0498H7.0598M10.5118 3H7.8C6.11984 3 5.27976 3 4.63803 3.32698C4.07354 3.6146 3.6146 4.07354 3.32698 4.63803C3 5.27976 3 6.11984 3 7.8V10.5118C3 11.2455 3 11.6124 3.08289 11.9577C3.15638 12.2638 3.27759 12.5564 3.44208 12.8249C3.6276 13.1276 3.88703 13.387 4.40589 13.9059L9.10589 18.6059C10.2939 19.7939 10.888 20.388 11.5729 20.6105C12.1755 20.8063 12.8245 20.8063 13.4271 20.6105C14.112 20.388 14.7061 19.7939 15.8941 18.6059L18.6059 15.8941C19.7939 14.7061 20.388 14.112 20.6105 13.4271C20.8063 12.8245 20.8063 12.1755 20.6105 11.5729C20.388 10.888 19.7939 10.2939 18.6059 9.10589L13.9059 4.40589C13.387 3.88703 13.1276 3.6276 12.8249 3.44208C12.5564 3.27759 12.2638 3.15638 11.9577 3.08289C11.6124 3 11.2455 3 10.5118 3ZM7.5498 7.0498C7.5498 7.32595 7.32595 7.5498 7.0498 7.5498C6.77366 7.5498 6.5498 7.32595 6.5498 7.0498C6.5498 6.77366 6.77366 6.5498 7.0498 6.5498C7.32595 6.5498 7.5498 6.77366 7.5498 7.0498Z"
        stroke="currentColor"
        strokeWidth="2"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </svg>
  );
};
export {
  CartIcon,
  ContactCardIcon,
  ContactCardIcon2,
  ListIcon,
  LockIcon,
  ReceiptIcon,
  ReceiptIcon2,
  SettingsIcon,
  ShopIcon,
  TagIcon,
};
